module.exports = __webpack_public_path__ + "static/media/wordmark.d9af42c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/logo/wordmark.png
// module id = 969
// module chunks = 0